<template>
  <div>
    <div v-if="demoMode" class="bpjs-demo-banner" role="status">
      <i class="fas fa-flask" aria-hidden="true"></i>
      <div>
        <strong>Mode Demo BPJS</strong>
        <span>Data pada halaman ini adalah simulasi lokal dan tidak dikirim ke BPJS Kesehatan.</span>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service"

export default {
  data: () => ({ demoMode: false }),
  async mounted() {
    try {
      const response = await ApiService.get("bpjs/settings")
      this.demoMode = Boolean(response.data && response.data.is_demo)
    } catch (error) {
      this.demoMode = false
    }
  },
}
</script>

<style lang="scss">
.bpjs-page {
  color: #243b53;
}
.bpjs-demo-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
  padding: 11px 14px;
  border: 1px solid #b9e6dc;
  border-radius: 12px;
  background: #effbf7;
  color: #176b5b;
}
.bpjs-demo-banner > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  flex: 0 0 34px;
  border-radius: 9px;
  background: #d8f5ec;
  color: #087f5b;
}
.bpjs-demo-banner strong,
.bpjs-demo-banner span { display: block; }
.bpjs-demo-banner strong { font-size: 12px; }
.bpjs-demo-banner span { margin-top: 1px; font-size: 11px; color: #52796f; }
.bpjs-hero {
  border: 0;
  border-radius: 16px;
  background: linear-gradient(135deg, #087f5b 0%, #0ca678 62%, #38d9a9 100%);
  color: #fff;
  box-shadow: 0 12px 30px rgba(8, 127, 91, 0.18);
}
.bpjs-card {
  border: 1px solid #e8f1ee;
  border-radius: 14px;
  box-shadow: 0 5px 18px rgba(40, 72, 65, 0.06);
}
.bpjs-form-card {
  overflow: visible;
}
.bpjs-form-card > .card-body {
  padding: 22px 24px;
}
.bpjs-filter-row {
  margin-right: -8px;
  margin-left: -8px;
}
.bpjs-filter-column {
  padding-right: 8px;
  padding-left: 8px;
}
.bpjs-form-control.form-control,
.bpjs-form-control.custom-select {
  height: 52px !important;
  min-height: 52px;
  border: 1px solid #d9e4ed !important;
  border-radius: 12px !important;
  background-color: #fff !important;
  box-shadow: none !important;
}
.bpjs-form-control.form-control:focus,
.bpjs-form-control.custom-select:focus {
  border-color: #8bcfc9 !important;
  box-shadow: 0 0 0 3px rgba(30, 149, 143, 0.1) !important;
}
.bpjs-control-button.btn {
  height: 52px !important;
  min-height: 52px;
  max-height: 52px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 0 20px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  box-shadow: none !important;
}
.bpjs-control-button.btn i,
.bpjs-control-button.btn .spinner-border {
  margin: 0 !important;
  color: inherit !important;
}
.bpjs-primary-action.btn {
  border-color: #168f89;
  background: #168f89;
  color: #fff;
}
.bpjs-primary-action.btn:hover,
.bpjs-primary-action.btn:focus {
  border-color: #117a75;
  background: #117a75;
  color: #fff;
}
.bpjs-primary-action.btn:disabled {
  border-color: #badbd8;
  background: #d8ecea;
  color: #5c8c89;
  opacity: 1;
}
.bpjs-outline-action.btn {
  border: 1px solid #1e958f;
  background: #fff;
  color: #1e958f;
}
.bpjs-outline-action.btn:hover,
.bpjs-outline-action.btn:focus {
  border-color: #1e958f;
  background: #f2fbfa;
  color: #1e958f;
}
.bpjs-outline-action.btn:disabled {
  border-color: #c7ddda;
  background: #f7fbfa;
  color: #789b98;
  opacity: 1;
}
.bpjs-card .card-header {
  border-bottom: 1px solid #edf4f2;
  background: #fff;
  border-radius: 14px 14px 0 0;
}
.bpjs-kpi {
  min-height: 132px;
}
.bpjs-kpi-icon {
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #e6fcf5;
  color: #087f5b;
  font-size: 20px;
  
  i {
    color: inherit !important;
  }
}
.bpjs-status-dot {
  width: 9px;
  height: 9px;
  display: inline-block;
  border-radius: 50%;
  margin-right: 7px;
  background: #adb5bd;
}
.bpjs-status-dot.active {
  background: #12b886;
  box-shadow: 0 0 0 4px rgba(18, 184, 134, 0.13);
}
.bpjs-result-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 12px;
}
.bpjs-result-item {
  padding: 12px 14px;
  border-radius: 10px;
  background: #f7faf9;
}
.bpjs-result-item small {
  color: #829ab1;
  display: block;
  margin-bottom: 4px;
}
.bpjs-result-value {
  min-width: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
}
.bpjs-result-value strong {
  min-width: 0;
  color: #21364d;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.bpjs-result-code {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 3px 8px;
  border: 1px solid #cfe9e5;
  border-radius: 7px;
  background: #edf8f6;
  color: #16867f;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.bpjs-empty {
  padding: 40px 20px;
  text-align: center;
  color: #829ab1;
}
.bpjs-table th {
  color: #627d98;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: .04em;
  border-top: 0;
}
@media (max-width: 767px) {
  .bpjs-hero .card-body { padding: 22px !important; }
  .bpjs-form-card > .card-body { padding: 18px; }
  .bpjs-filter-column + .bpjs-filter-column { margin-top: 14px; }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .bpjs-action-column { margin-top: 14px; }
}
</style>
